import { AuthService } from "@/modules/auth/services/authService";
import { RiskService } from "@/modules/risk/services/riskService";
import { ChatService } from "@/modules/chat/services/chatService";
import { IssueService } from "@/modules/issue/services/issueService";
import { BusinessRequirementsService } from "@/modules/proposal-management/business-requirements/services/businessRequirementsService";
import { BusinessRequirementEstimatesService } from "@/modules/proposal-management/business-requirement-estimates/services/businessRequirementEstimatesService";
import { RfpAnalysisService } from "@/modules/proposal-management/rfp-analysis/services/rfpAnalysisService";
import { RomEffortEstimatesService } from "@/modules/proposal-management/rom-effort-estimates/services/romEffortEstimatesService";
import { UserService } from "@/modules/admin/services/userService";
import { RoleService } from "@/modules/admin/services/roleService";
import { SkillService } from "@/modules/admin/services/skillService";
import { ProjectService } from "@/modules/project/services/projectService";
import type { ServiceSpec } from "./types";

export const services = [
  {
    name: "auth",
    init: (context) => new AuthService(context.httpClient),
  },
  {
    name: "risk",
    init: (context) => new RiskService(context.httpClient),
  },
  {
    name: "chat",
    init: (context) => new ChatService(context.httpClient),
  },
  {
    name: "issue",
    init: (context) => new IssueService(context.httpClient),
  },
  {
    name: "businessRequirements",
    init: (context) => new BusinessRequirementsService(context.httpClient),
  },
  {
    name: "businessRequirementEstimates",
    init: (context) =>
      new BusinessRequirementEstimatesService(context.httpClient),
  },
  {
    name: "rfpAnalysis",
    init: (context) => new RfpAnalysisService(context.httpClient),
  },
  {
    name: "romEffortEstimates",
    init: (context) => new RomEffortEstimatesService(context.httpClient),
  },
  {
    name: "adminUsers",
    init: (context) => new UserService(context.httpClient),
  },
  {
    name: "adminRoles",
    init: (context) => new RoleService(context.httpClient),
  },
  {
    name: "adminSkills",
    init: (context) => new SkillService(context.httpClient),
  },
  {
    name: "project",
    init: (context) => new ProjectService(context.httpClient),
  },
] as const satisfies ReadonlyArray<ServiceSpec>;
